import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { HotKeys } from 'react-hotkeys';

import Button from '../../../../global/Button';
import { IMAGE_SIZE_CODE } from '../../../../../constants/image-size-codes';
import AlbumSlideshowThumbnailControls from './AlbumSlideshowThumbnailControls';
import PhotoUploadCache from '../../../../product/PhotoUploadCache';
import { getThumbBySize } from '../../../../../util/photo';
import AccountCard from '../../../../../services/cards/components/AccountCard';

const propTypes = {
  slideshowSlide: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
  isSeen: PropTypes.bool,
  slideDuration: PropTypes.number,
  slideRemainingTime: PropTypes.number,
  className: PropTypes.string,
  onDelete: PropTypes.func,
  onMoveLeft: PropTypes.func,
  onMoveRight: PropTypes.func,
  style: PropTypes.object,
};

const AlbumSlideshowThumbnail = ({
  slideshowSlide,
  onClick,
  isActive,
  isSeen,
  slideDuration,
  slideRemainingTime,
  className,
  onDelete,
  onMoveLeft,
  onMoveRight,
  disabled,
  style,
}) => {
  const classes = classNames({
    'slideshow-grid-viewer-thumbnail': true,
    'is-active': isActive,
    [className]: !!className,
  });

  return (
    <HotKeys
      keyMap={{
        onMoveRight: onMoveRight ? 'right' : undefined,
        onMoveLeft: onMoveLeft ? 'left' : undefined,
      }}
      handlers={{ onMoveRight, onMoveLeft }}
      style={style}
    >
      {isActive && (
        <AlbumSlideshowThumbnailControls
          disabled={disabled}
          onMoveLeft={onMoveLeft}
          onDelete={onDelete}
          onMoveRight={onMoveRight}
        />
      )}
      <Button btnStyle="reset" className={classes} onClick={onClick}>
        {(isSeen || isActive) && (
          <div
            className="thumbnail-seen-overlay"
            style={{
              width: isSeen
                ? '100%'
                : `${100 - (100 * slideRemainingTime) / slideDuration}%`,
            }}
          />
        )}
        {slideshowSlide.account_card &&
          !slideshowSlide.account_card.front_preview_file_url && (
            <div className="w-100">
              <AccountCard
                onElementConfigurationChange={() => {}}
                accountCard={slideshowSlide.account_card}
                animatable={false}
                viewOnly
                disablePhotoWatermarkOverlay
              />
            </div>
          )}
        {(!slideshowSlide.account_card ||
          !!slideshowSlide.account_card.front_preview_file_url) && (
          <PhotoUploadCache
            id={
              slideshowSlide.asset_image?.id ??
              slideshowSlide.photo?.id ??
              slideshowSlide.account_card?.id
            }
            thumbs={(() => {
              if (slideshowSlide.asset_image) {
                return [
                  {
                    width: 1,
                    height: 1,
                    size_code: IMAGE_SIZE_CODE.SMALL2X,
                    ...slideshowSlide.asset_image,
                  },
                ];
              }

              if (slideshowSlide.account_card) {
                const { account_card } = slideshowSlide;
                return [
                  {
                    width: 1,
                    height: 1,
                    size_code: IMAGE_SIZE_CODE.SMALL2X,
                    id: account_card?.id,
                    url: account_card?.front_preview_file_url,
                  },
                ];
              }

              return (
                slideshowSlide.photo?.watermarked_urls ??
                slideshowSlide.photo?.thumbnail_urls ??
                []
              );
            })()}
            render={thumbs => (
              <img
                src={getThumbBySize(thumbs, IMAGE_SIZE_CODE.SMALL2X, true)?.url}
                alt="Slideshow Thumbnail"
              />
            )}
          />
        )}
      </Button>
    </HotKeys>
  );
};

AlbumSlideshowThumbnail.propTypes = propTypes;

export default AlbumSlideshowThumbnail;
